import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('ExterneOrganisation')

export default {
  label: 'Externe Organisation',
  route: 'externeorganisation',
  className: 'externeOrganisation',
  fields: [
    Filter.String('name'),
    Filter.String('stadt'),
    Filter.String('kurzname'),
    Filter.String('beschreibung'),
    Filter.ReferenceBySearchRep('land', 'globe')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/ExterneOrganisationFilter.js